import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import { VRI_LOGO_DATA_URI } from '../assets/logo';

export interface TagLabelData {
  code: string;
  title: string;
  subtitle?: string;
}

/**
 * A single printable asset/inventory tag: Verdantrise branding, the
 * item's name, and a genuinely scannable Code128 barcode encoding its
 * real asset_number or item_code - not a decorative barcode-shaped
 * image, an actual one a handheld warehouse scanner or barcode phone
 * app can read back to the exact code. Code128 chosen over QR as the
 * primary format because it reads reliably on the low-cost handheld
 * scanners typical in warehouse operations; sized to fit a standard
 * 2-inch x 1-inch label (the common Avery/thermal label size) so a
 * sheet of these prints directly onto real label stock.
 */
export function TagLabel({ code, title, subtitle }: TagLabelData) {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (svgRef.current) {
      JsBarcode(svgRef.current, code, {
        format: 'CODE128',
        width: 1.6,
        height: 32,
        displayValue: true,
        fontSize: 11,
        margin: 0,
        background: 'transparent',
      });
    }
  }, [code]);

  return (
    <div className="tag-label">
      <div className="tag-label-header">
        <img src={VRI_LOGO_DATA_URI} alt="" className="tag-label-logo" />
        <span className="tag-label-org">VERDANTRISE</span>
      </div>
      <div className="tag-label-title">{title}</div>
      {subtitle && <div className="tag-label-subtitle">{subtitle}</div>}
      <svg ref={svgRef} className="tag-label-barcode" />
    </div>
  );
}
